import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <center>
    <div >
      <div >
        <h1 >404</h1>
        <p >We can't seem to find the page you're looking for.</p>
        <Link to="/" >
          <span >Go Home</span>
        </Link>
      </div>
    </div>
    </center>
  );
};


export default NotFound;
